import { bool, boolean, number, object, string, array, mixed } from 'yup'
import { isValidUrl, validateAddressComponent, validateAddressComponentsArray } from 'src/utils/yupCustomMethods'
import { validateOptionalDate } from 'src/utils/formDataManipulation'


const phoneRegExp = /^\(\d{3}\)-\d{3}-\d{4}$/;

// main page add route
export const FirmInfoSchema = object({
    // firmName: string().required('step1'),
    // practiceType: string().required('step2'),
    // contactInfo: object({
    //   phoneNumber: string().min(14, 'step4').matches(phoneRegExp,'step4').required('step4'),
    //   website: string().optional().nullable().test('step10','step10',val => isValidUrl(val)),
    //   faxNumber: string().optional().nullable(),
    // }),
    // mailAddress: object({
    //   addressComponents: array().of(object({
    //     shortName: string().test('component-test', 'step5', validateAddressComponent),
    //     types: array().of(string()).required('step5')
    //   })).test('component-array', 'step5', validateAddressComponentsArray).required('step5')
    // }),
    // isBillingEqualToMail: boolean().required('step6'),
    // billingAddress: object().when('isBillingEqualToMail', {
    //   is: false,
    //   then: object({
    //     addressComponents: array().of(object({
    //       shortName: string().test('component-test', 'step6', validateAddressComponent),
    //       types: array().of(string()).required('step6')
    //     })).test('component-array', 'step6', validateAddressComponentsArray).required('step6')
    //   }),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // isSecondaryContactAdded: boolean().required('step7'),
    // secondaryContact: object().when('isSecondaryContactAdded', {
    //   is: true,
    //   then: object({
    //     firstName: string().typeError('step7').required('step7'),
    //     lastName: string().typeError('step7').required('step7'),
    //     phoneNumber: string().typeError('step7').required('step7'),
    //     emailAddress: string().typeError('step7').required('step7').email('step7'),
    //   }),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasFormalLetterhead: boolean().typeError('step8').required('step8'),
    // formalLetterheadFile: array().when('hasFormalLetterhead', {
    //   is: true,
    //   then: sch => sch.min(1, 'step8').of(object({
    //     id: string().typeError('step8').required('step8'),
    //     fileName: string().typeError('step8').required('step8'),
    //     fileUrl: string().typeError('step8').required('step8')
    //   }).typeError('step8').required('step8')).required('step8'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // formalLetterheadDescription: string().when('hasFormalLetterhead', {
    //   is: false,
    //   then: sch => sch.typeError('step8').required('step8'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // numberOfOffices: string().typeError('step9').required('step9'),
  });

  // customer/renew/attorneys/left
  export const FirmRealEstateSchema = object({
    // hasFirmMemberWithEscrowLicense: bool().required('step1'),
    // hasAgreementWithTitleCompanies: bool().required('step2'),
    // agreementWithTitleCompaniesFile: array().when('hasAgreementWithTitleCompanies', {
    //   is: true,
    //   then: sch => sch.min(1, 'step2').required('step2'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasFirmMemberFeeAttorney: bool().required('step3'),
    // hasFirmMemberOutsideClosingAttorney: bool().required('step4'),
    // nonAttorneysWithEscrowLicenseQuantity: number().required('step5'),
  });

  // customer/renew/firm/securities-law
  export const FirmSecurityLawSchema = object({
    // conductsDueDiligenceInvestigation: boolean().typeError('step1').required('step1'),
    // involvedInActionByRegulator: boolean().typeError('step2').required('step2'),
    // involvedInActionByRegulatorDescription: string().when('involvedInActionByRegulator', {
    //   is: true,
    //   then: sch => sch.required('step2'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasPreparedPortionOfProspectus: boolean().typeError('step3').required('step3'),
    // involvedInDirectSale: boolean().typeError('step4').required('step4'),
    // hasAcceptedEquityInterest: boolean().typeError('step5').required('step5'),
    // acceptEquityInterestCircumstances: string().when('hasAcceptedEquityInterest', {
    //   is: true,
    //   then: sch => sch.required('step5'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // acceptEquityInterestApprovalProcess: string().when('hasAcceptedEquityInterest', {
    //   is: true,
    //   then: sch => sch.required('step5'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasProvidedLegalServicesForOfficers: boolean().typeError('step6').required('step6'),
    // hasProvidedLegalServicesOwnedInterests: boolean().typeError('step7').required('step7')
  });

  // customer/renew/attorneys/left
  export const FirmAttorneysLeftSchema = object({
    // hasLeavingAttorneys: bool().required('option_choose_required'),
    // departingAttorneys: array().when('hasLeavingAttorneys', {
    //   is: true,
    //   then: sch => sch.of(object({
    //     attorneyName: string().required('name_required'),
    //     leavingDate: string().trim().length(10, 'leaving_date_required').validDate('leaving_date_required').typeError('leaving_date_required').required('leaving_date_required')
    //   })).min(1, 'select_attorney_required').required('select_attorney_required'),
    //   otherwise: sch => sch.optional().nullable()
    // })
  })

  // customer/renew/attorneys/joined
  export const FirmAttorneysJoinedSchema = object ({
    // firstName: string().required('mainSection'),
    // lastName: string().required('mainSection'),
    // isResumeAvailable: bool().required('mainSection'),
    // resumeFile: array().when('isResumeAvailable', {
    //   is: true,
    //   then: sch => sch.min(1, 'mainSection').of(object({
    //     id: number().required('mainSection'),
    //     fileName: string().required('mainSection'),
    //     fileUrl: string().required('mainSection')
    //   })).required('mainSection'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // barCardNumber: string().required('aboutSection'),
    // position: string().required('aboutSection'),
    // emailAddress: string().email().required('aboutSection'),
    // yearsInPrivatePractice: string().required('aboutSection'),
    // license: object({
    //   //licenseDate: string().validDate('licensingSection').required('licensingSection'),
    //   licenseDate: string().trim().nullable()
    //     .when('isLicensedInOtherState', {
    //       is: false,
    //       then: string().trim().length(10).required('licensingSection'),
    //       otherwise: string().trim().optional().nullable().test('licensingSection', 'licensingSection', val => validateOptionalDate(val))
    //     }),
    //   isLicensedInOtherState: bool().required('licensingSection')
    // }).required('licensingSection'),
    // workHistory: object().when('isResumeAvailable', {
    //   is: false,
    //   then: object({
    //     noEmploymentHistory: mixed().optional().oneOf([true, false, null]),//bool().required('historySection'),
    //     joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    //     hoursPerWeek: number().moreThan(0, 'historySection').required('historySection'),
    //     formerEmployers: array().when('noEmploymentHistory', {
    //       is: false || undefined,
    //       then: schema => schema.of(
    //         object().shape({
    //           firmName: string().required('historySection'),
    //           position: string().required('historySection'),
    //           employmentDateFrom: string().trim().length(7, 'historySection').required('historySection'),
    //           employmentDateTo: string().trim().length(7, 'historySection').required('historySection'),
    //         })
    //       ),
    //       otherwise: schema => schema.notRequired()
    //     }
    //     ),
    //   }),
    //   otherwise: object({
    //     noEmploymentHistory: mixed().optional().oneOf([true, false, null]),
    //     joinedDate: string().trim().length(10, 'historySection').validDate('historySection').required('historySection'),
    //     hoursPerWeek: number().moreThan(0, 'historySection').required('historySection'),
    //     formerEmployers: array().notRequired().nullable(),
    //   })
    // })
  });

  // customer/renew/attorneys/verify
  export const FirmAttorneysVerifySchema = object ({
    // firstName: string().required('mainSection'),
    // lastName: string().required('mainSection'),
    // isResumeAvailable: bool().required('mainSection'),
    // barCardNumber: string().required('aboutSection'),
    // position: string().required('aboutSection'),
    // emailAddress: string().email().required('aboutSection'),
    // yearsInPrivatePractice: string().required('aboutSection'),
    // license: object({
    //   //licenseDate: string().validDate('licensingSection').required('licensingSection'),
    //   licenseDate: string().trim().nullable()
    //     .when('isLicensedInOtherState', {
    //       is: false,
    //       then: string().trim().length(10).test('licensingSection', 'licensingSection', val => validateOptionalDate(val)).required('licensingSection'),
    //       otherwise: string().trim().optional().nullable().test('licensingSection', 'licensingSection', val => validateOptionalDate(val))
    //     }),
    //   isLicensedInOtherState: bool().required('licensingSection'),
    //   licensesInfo: string().when('isLicensedInOtherState', {
    //     is: true,
    //     then: info => info.trim().required('licensingSection'),
    //     otherwise: info => info.optional().nullable()
    //   }),
    // }).required('licensingSection'),
    // workHistory: object({
    //   joinedDate: string().validDate('historySection').required('historySection'),
    //   hoursPerWeek: number().moreThan(0, 'historySection').required('historySection')
    // }).required('historySection')
  });

  // customer/renew/attorneys/ic-oc
  export const FirmAttorneysICOCSchema = object({
    // firstName: string().typeError('attorneyName').required('attorneyName'),
    // lastName: string().typeError('attorneyName').required('attorneyName'),
    yearStartedAsICOC: number().integer('yearStartedAsICOC').typeError('yearStartedAsICOC').moreThan(1900, 'yearStartedAsICOC').required('yearStartedAsICOC'),
    hoursOnBill: number().integer('hoursOnBill').typeError('hoursOnBill').required('hoursOnBill'),
    //   .when('hoursBilledInFirstYear', {
    //   is: (value: number | string) => !value === true,
    //   then: sch => sch.moreThan(0, 'hoursOnBill').typeError('hoursOnBill').required('hoursOnBill'),
    //   otherwise: sch => sch.typeError('typeerror').optional().nullable()
    // }),
    hoursBilledInFirstYear: number().integer('hoursBilledInFirstYear').typeError('hoursBilledInFirstYear').required('hoursBilledInFirstYear'),
    //   .when('hoursOnBill', {
    //   is: (value: number | string) => !value === true,
    //   then: sch => sch.moreThan(0, 'hoursBilledInFirstYear').typeError('hoursBilledInFirstYear').required('hoursBilledInFirstYear'),
    //   otherwise: sch => sch.typeError('typeerror').optional().nullable()
    // }),
   }) //[['hoursOnBill', 'hoursBilledInFirstYear']]);

  // customer/renew/questions/main
  export const FirmQuestionsMainSchema: any = object ({
    // hasICOCAttorneys: bool().typeError('step1').required('step1'),
    // hasICOCAttorneysDescription: string().when('hasICOCAttorneys', {
    //   is: true,
    //   then: sch => sch.required('step1'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasJointVentureAttorneys: bool().typeError('step2').required('step2'),
    // hasJointVentureAttorneysDescription: string().when('hasJointVentureAttorneys', {
    //   is: true,
    //   then: sch => sch.required('step2'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasEquityInterestAttorneys: bool().typeError('step3').required('step3'),
    // hasOtherEntityAttorneys: bool().typeError('step4').required('step4'),
    // hasOtherEntityAttorneysDescription: string().when('hasOtherEntityAttorneys', {
    //   is: true,
    //   then: sch => sch.required('step4'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasAdvisorAttorney: bool().typeError('step5').required('step5'),
    // hasAdvisorAttorneyDescription: string().when('hasAdvisorAttorney', {
    //   is: true,
    //   then: sch => sch.required('step5'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasStartedSharingSpace: bool().typeError('step6').required('step6'),
    // sharedExpenseEntities: array().when('hasStartedSharingSpace', {
    //   is: true,
    //   then: sch => sch.of(object({
    //     name: string().required('step6'),
    //     dateSharingBegan: string().trim().length(10, 'step6').validDate('step6').required('step6')
    //   })).min(1, 'step6').required('step6'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasSueForFeesPolicy: bool().typeError('step7').required('step7'),
    // hasSueForFeesPolicyDescription: number().when('hasSueForFeesPolicy', {
    //   is: true,
    //   then: sch => sch.required('step7'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasTlieSponsoredCle: bool().typeError('step8').required('step8'),
    // hasMalPracticeClaims: bool().typeError('step9').required('step9'),
    // hasMalPracticeClaimsReported: bool().when('hasMalPracticeClaims', {
    //   is: true,
    //   then: sch => sch.typeError('step9').required('step9'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasMalPracticeBasis: bool().typeError('step10').required('step10'),
    // hasMalPracticeBasisReported: bool().when('hasMalPracticeBasis', {
    //   is: true,
    //   then: sch => sch.typeError('step10').required('step10'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasGrievanceComplain: bool().typeError('step11').required('step11'),
    // hasGrievanceComplainReported: bool().when('hasGrievanceComplain', {
    //   is: true,
    //   then: sch => sch.typeError('step11').required('step11'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasGrievanceComplainFile: object().when('hasGrievanceComplainReported', {
    //   is: false,
    //   then: sch => sch.shape({
    //     fileName: string().required('step11'),
    //     fileUrl: string().required('step11')
    //   }).required('step11'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasVoluntarilyAcceptedDiscipline: bool().typeError('step12').required('step12'),
    // hasVoluntarilyAcceptedDisciplineDescription: string().when('hasVoluntarilyAcceptedDiscipline', {
    //   is: true,
    //   then: sch => sch.required('step12'),
    //   otherwise: sch => sch.optional().nullable()
    // })
  });

  // customer/renew/questions/equity-interest
  export const FirmQuestionsEquityIntSchema = object ({
    // providesWrittenDisclosure: boolean().typeError('step1').required('step1'),
    // acceptedEquityOfAttorneysFees: boolean().typeError('step2').required('step2'),
    // acceptedEquityOfAttorneysFeesDescription: string().when('acceptedEquityOfAttorneysFees', {
    //   is: true,
    //   then: sch => sch.required('step2'),
    //   otherwise: sch => sch.nullable().notRequired()
    // }),
    // providedProfessionalLegalServices: boolean().typeError('step3').required('step3'),
    // providedProfessionalLegalServicesDescription: string().when('providedProfessionalLegalServices', {
    //   is: true,
    //   then: sch => sch.required('step3'),
    //   otherwise: sch => sch.nullable().notRequired()
    // })
  });

  // customer/renew/quote/select
  export const FirmQuoteSchema = object ({
    // liabilityLimits: string().required('liabilityLimits'),
    // deductible: string().required('deductible')
  });

  // JUDGE

  // customer/renew/juge/basic/main
  export const JudgeMainInfoSchema = object ({
    // firstName: string().typeError('step1').required('step1'),
    // lastName: string().typeError('step1').required('step1'),
    // contactInfo: object({
    //   firstName: string().typeError('step2').required('step2'),
    //   lastName: string().typeError('step2').required('step2'),
    //   phoneNumber: string().typeError('step2').min(14, 'step2').required('step2'),
    //   emailAddress: string().typeError('step2').email('step2').required('step2'),
    //   faxNumber: string().optional().nullable(),
    // }),
    // principalOfficeAddress: object({
    //   addressComponents: array().of(object({
    //     shortName: string().test('component-test', 'step3', validateAddressComponent),
    //     types: array().of(string()).required('step3')
    //   })).test('component-array', 'step3', validateAddressComponentsArray).required('step3')
    // }),
    // presidingCounty: string().typeError('step4').required('step4')
  });

  // customer/renew/judge/questions/main
  export const JudgeQuestionsMainSchema = object ({
    // hasBeenSubjectOfClaim: boolean().typeError('step1').required('step1'),
    // hasClaimBeenReported: boolean().when('hasBeenSubjectOfClaim', {
    //   is: true,
    //   then: sch => sch.typeError('step1').required('step1'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasBasisForClaim: boolean().typeError('step2').required('step2'),
    // hasBasisForClaimReported: boolean().when('hasBasisForClaim', {
    //   is: true,
    //   then: sch => sch.typeError('step2').required('step2'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
    // hasBeenSubjectOfAction: boolean().typeError('step3').required('step3'),
    // hasBeenSubjectOfActionDetails: string().when('hasBeenSubjectOfAction', {
    //   is: true,
    //   then: sch => sch.typeError('step3').required('step3'),
    //   otherwise: sch => sch.optional().nullable()
    // }),
  });

